import React, { FC } from 'react';
import { Box } from '@mui/material';
import { useReactiveVar } from '@apollo/client';

import { questions as questionsState } from '../../states/questionBuilderState';

import DropContainer from './DropContainer';
import EmptyContainer from './EmptyContainer';

interface QuestionsContainerProps {
  enableRTE?: boolean;
}

const QuestionsContainer: FC<QuestionsContainerProps> = ({ enableRTE }) => {
  const questions = useReactiveVar(questionsState);

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="70%"
      marginLeft="24px"
      borderRadius="15px"
    >
      {questions.length ? (
        questions.map((item, index) => (
          <DropContainer
            item={item}
            index={index}
            key={item.id}
            enableRTE={enableRTE}
          />
        ))
      ) : (
        <EmptyContainer />
      )}
    </Box>
  );
};

export default QuestionsContainer;
